import React, { useState } from 'react';
import { BaseModal, ToastMessage } from '@cokitchen/cokitchen-components';
import PartnerThirdStep, { ManagerFieldType } from '../partners/steps/partner-third-step';
import AddManagersFooter from './add-managers-footer';
import { toast } from 'react-toastify';
import { PartnerType } from 'models/partner.model';
import { ManagerFormType } from '../partners/steps/types';
import { apiService } from 'utils/api';
import { RidersIcon } from 'cokitchen-icons';
type AddRidersProps = {
  onClose: () => void;
  partner: PartnerType;
};

export type AddManagerFormType = {
  logistics_admins: ManagerFormType[];
};

const AddMananagersModal = ({ onClose, partner }: AddRidersProps) => {
  const EMPTY_FORM = {
    first_name: '',
    phone_number: '',
    email: '',
    user_gender: '',
    last_name: ''
  };
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    logistics_admins: [EMPTY_FORM]
  } as AddManagerFormType);
  const addManagers = async () => {
    setLoading(false);
    const data = {
      logistics_company_id: partner.id,
      ...formData
    };
    try {
      await apiService.post('logistics/register-logistics-admin', {
        data,
        baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
      });

      toast(<ToastMessage type='success' message='Managers added successfully' />);
      onClose();
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err.response.data.message} />);
    } finally {
      setLoading(false);
    }
  };

  const additionalManagers = () => {
    const logistics_admins = [...formData.logistics_admins, EMPTY_FORM];
    setFormData({
      ...formData,
      logistics_admins: [...logistics_admins]
    });
  };

  const handleAddManagers = (e: any, i: number, field: ManagerFieldType) => {
    const logistics_admins = [...formData.logistics_admins];
    if (field === 'user_gender') {
      logistics_admins[i][field] = e;
    } else {
      logistics_admins[i][field] = e.target.value;
    }
    setFormData({ ...formData });
  };

  const confirmDisabled = () => {
    for (let i = 0; i < formData.logistics_admins.length; i++) {
      const { first_name, last_name, email, phone_number, user_gender } =
        formData.logistics_admins[i];
      if (!first_name || !last_name || !email || !phone_number || !user_gender) {
        return true;
      }
    }
    return false;
  };

  const handleDelete = (i: number) => {
    const filteredManagers = formData.logistics_admins.filter((manager, index) => index !== i);
    formData.logistics_admins = filteredManagers;
    setFormData({ ...formData });
  };
  return (
    <BaseModal
      position='right'
      isOpen
      onRequestClose={onClose}
      title='Add Managers'
      titleIcon={<RidersIcon />}
      titleCta={
        <span role='button' className='text-red-5' onClick={additionalManagers}>
          + Additional manager
        </span>
      }
      footer={
        <AddManagersFooter disabled={confirmDisabled()} loading={loading} onClick={addManagers} />
      }>
      <PartnerThirdStep
        formData={formData}
        handleAddManagers={handleAddManagers}
        handleDelete={handleDelete}
      />
    </BaseModal>
  );
};

export default AddMananagersModal;
